import Question from './Question.container';

export default Question;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/question/index.js